module.exports = __webpack_public_path__ + "img/bg-circle.dc0b26de.png";